import { splitPath } from './splitPath';

export function normalisePath(
  path: string | null): string {

  return splitPath(path, true).join('?');
}
